import PlainTextCell from 'components/PlainTextCell';

type Props = {
  rowData: Pick<SentinelTeam, 'totals'>;
};

export default function MembersCell({ rowData: { totals } }: Props) {
  return <PlainTextCell textAlign="end" topLine={totals?.members?.total} />;
}
